export default {
  me: function me(state) {
    return state.user;
  }
};